import { getParamsFromQueryString } from './url'
import { urls, env } from '../components/list/SystemLinksList'
import saraivaLogo from '../assets/logo/saraiva_logo_black.png'
import saraivaForSchoolsLogo from '../assets/logo/saraiva_para_escolas.svg'
import redeprofLogo from '../assets/logo/redeprof.svg'
import bancoDeQuestoesLogo from '../assets/logo/banco_de_questoes.svg'
import profAppLogo from '../assets/logo/prof-app.svg'
import obeconLogo from '../assets/logo/obecon.svg'
import redacaoLogo from '../assets/logo/redacao.svg'
import somaLogo from '../assets/logo/soma.svg'
import bertoniMedLogo from '../assets/logo/bertonimed-logo.svg'
import opmbrLogo from '../assets/logo/logo-opmbr.svg'
import LigaOlimpiadasLogo from '../assets/logo/LigaOlimpiadasLogo.png'
import fronteirasLogo from '../assets/logo/logo-fronteiras-edu.png'
import verboSeriosLogo from '../assets/logo/logo-serios.svg'
import verboAtrioLogo from '../assets/atrio/logo_atrio.svg'
import verboEducandarioLogo from '../assets/logo/logo-educandario-default-blue-horizontal.png'
const verboLogo = 'https://cdn.fractaltecnologia.com.br/images/verbo-ui/verbo-default-logo-full-purple.svg'
const MundoKidsLogo = 'https://cdn.fractaltecnologia.com.br/images/mundo-kids/logo-mundokids-amarelo.svg'
const verboNationsLogo = 'https://cdn.fractaltecnologia.com.br/images/nations-verbo/full-colored-logo.png'

const fractalApps = {
  '1': () => ({
    name: 'Saraiva para Escolas',
    logo: saraivaForSchoolsLogo,
    theme: {
      primaryColor: '#FFD344'
    }
  }),
  '10': () => ({
    name: 'Prof',
    logo: profAppLogo,
    theme: {
      primaryColor: '#412A88'
    }
  }),
  '16': () => ({
    name: 'Redeprof',
    logo: redeprofLogo,
    theme: {
      primaryColor: '#0079B3'
    }
  }),
  '17': () => ({
    name: 'Banco de Questões',
    logo: bancoDeQuestoesLogo,
    theme: {
      primaryColor: '#0079B3'
    }
  }),
  '18': () => ({
    name: 'Admin Prof',
    logo: profAppLogo,
    theme: {
      primaryColor: '#412A88'
    },
    redirectUrl: urls[env]['adminProf']
  }),
  '22': () => ({
    name: 'CRM Saraiva',
    logo: saraivaLogo,
    theme: {
      primaryColor: '#FFC541'
    }
  }),
  '23': () => ({
    name: 'Olimpíada Sapientia',
    logo: 'https://fractal-public-assets.s3-sa-east-1.amazonaws.com/img/logo-sapienta2.svg',
    theme: {
      primaryColor: '#0079B3'
    },
    redirectUrl: urls[env]['sapientia']
  }),
  '26': () => ({
    name: 'Olimpíada Vitalis',
    logo: 'https://fractal-public-assets.s3-sa-east-1.amazonaws.com/img/logo_vitalis.svg',
    theme: {
      primaryColor: '#0079B3'
    },
    redirectUrl: urls[env]['vitalis']
  }),
  '28': () => ({
    name: 'OBECON - Olimpíada Brasileira de Economia',
    logo: obeconLogo,
    theme: {
      primaryColor: '#383838'
    },
    redirectUrl: urls[env]['obecon']
  }),
  '29': () => ({
    name: 'Olimpíada Pocket',
    logo: 'https://fractal-public-assets.s3-sa-east-1.amazonaws.com/img/logo_pocket.svg',
    theme: {
      primaryColor: '#383838'
    },
    redirectUrl: urls[env]['pocket']
  }),
  '31': () => ({
    name: 'OBL - Olimpíada Brasileira de Linguística',
    logo: 'https://fractal-public-assets.s3-sa-east-1.amazonaws.com/img/logo-obling.png',
    theme: {
      primaryColor: '#B5612D'
    },
    redirectUrl: urls[env]['obling']
  }),
  '32': () => ({
    name: 'MNCTI - Ministério da Ciência, Tecnologia e Inovações',
    logo: 'https://fractal-public-assets.s3-sa-east-1.amazonaws.com/img/logo-mncti.png',
    theme: {
      primaryColor: '#10C964'
    },
    redirectUrl: urls[env]['mncti']
  }),
  '33': () => ({
    name: 'Olimpíadas da Economia',
    logo: 'https://fractal-public-assets.s3-sa-east-1.amazonaws.com/img/logo-opecon.svg',
    theme: {
      primaryColor: '#4B4B4B'
    },
    redirectUrl: urls[env]['opecon']
  }),
  '34': () => ({
    name: 'Versar - Platoforma Socioemocional',
    logo: 'https://fractal-public-assets.s3-sa-east-1.amazonaws.com/img/logo_versar.svg',
    theme: {
      primaryColor: '#386093'
    },
    redirectUrl: urls[env]['versar']
  }),
  '35': () => ({
    name: 'Redação Solidária',
    logo: redacaoLogo,
    theme: {
      primaryColor: '#4464ad',
      secondaryColor: '#eae380'
    },
    redirectUrl: urls[env]['redacao']
  }),
  '36': () => ({
    name: 'Olimpíadas Celeritas',
    logo: 'https://fractal-public-assets.s3-sa-east-1.amazonaws.com/img/logo_celeritas.svg',
    theme: {
      primaryColor: '#1c4374'
    },
    redirectUrl: urls[env]['celeritas']
  }),
  '37': () => ({
    name: 'Olimpíada Brasileira de Biologia Sintética',
    logo: 'https://fractal-public-assets.s3-sa-east-1.amazonaws.com/img/logo_obbs.svg',
    theme: {
      primaryColor: '#6FBC89'
    },
    redirectUrl: urls[env]['obbs']
  }),
  '38': () => ({
    name: 'Átrio',
    logo: 'https://cdn.fractaltecnologia.com.br/images/logo-atrio-login.svg',
    theme: {
      primaryColor: '#003770',
      secondaryColor: '#E94F1B'
    }
  }),
  '39': () => ({
    name: 'Prof Seriös',
    logo: 'https://cdn.fractaltecnologia.com.br/images/logo-serios-login.svg',
    theme: {
      primaryColor: '#8C162C',
      secondaryColor: '#6E6E6E'
    },
    redirectUrl: urls[env]['profSerios']
  }),
  '40': () => ({
    name: 'PPA',
    logo: 'https://fractal-public-assets.s3.sa-east-1.amazonaws.com/img/logo-ppa.svg',
    theme: {
      primaryColor: '#D01C61'
    }
  }),
  '41': () => ({
    name: 'Bertoni Med',
    logo: bertoniMedLogo,
    theme: {
      primaryColor: '#000000'
    }
  }),
  '42': () => ({
    name: 'Bertoni',
    logo: 'https://fractal-public-assets.s3.sa-east-1.amazonaws.com/icons/logo-rede-bertoni.svg',
    theme: {
      primaryColor: '#012326'
    },
    redirectUrl: urls[env]['bertoni']
  }),
  '43': () => ({
    name: 'Kingdom',
    logo: 'https://fractal-public-assets.s3-sa-east-1.amazonaws.com/img/kingdom-logo.svg',
    theme: {
      primaryColor: '#5214FF',
      secondaryColor: '#FFA201'
    },
    redirectUrl: urls[env]['kingdom']
  }),
  '44': () => ({
    name: 'SOMA',
    logo: somaLogo,
    theme: {
      primaryColor: '#5FBFED'
    },
    redirectUrl: urls[env]['soma']
  }),
  '46': () => ({
    name: 'Serios',
    logo: 'https://cdn.fractaltecnologia.com.br/images/logo-seriosv2.svg',
    theme: {
      primaryColor: '#871432',
      secondaryColor: '#5F2433'
    },
    redirectUrl: urls[env]['serios']
  }),
  '47': () => ({
    name: 'OPMBR',
    logo: opmbrLogo,
    theme: {
      primaryColor: '#6EB64C',
      secondaryColor: '#2CB8D1'
    },
    redirectUrl: urls[env]['opmbr']
  }),
  '48': () => ({
    name: 'Versar - Platoforma Socioemocional',
    logo: 'https://fractal-public-assets.s3-sa-east-1.amazonaws.com/img/logo_versar.svg',
    theme: {
      primaryColor: '#386093'
    },
    redirectUrl: urls[env]['versar']
  }),
  '49': () => ({
    name: 'Escola do Ser',
    logo: 'https://cdn.fractaltecnologia.com.br/images/logo-esc-v1.svg',
    theme: {
      primaryColor: '#2A1C45'
    },
    redirectUrl: urls[env]['esc']
  }),
  '51': () => ({
    name: 'Versar HOMOLOG - Platoforma Socioemocional',
    logo: 'https://fractal-public-assets.s3-sa-east-1.amazonaws.com/img/logo_versar.svg',
    theme: {
      primaryColor: '#386093'
    },
    redirectUrl: urls[env]['versar-homolog']
  }),
  '52': () => ({
    name: 'Plataforma Verbo',
    logo: verboLogo,
    theme: {
      primaryColor: '#3e02a3',
      secondaryColor: '#45cfef'
    },
    redirectUrl: urls[env]['verbo']
  }),
  '57': () => ({
    name: 'Fronteiras da Educação',
    logo: fronteirasLogo,
    theme: {
      primaryColor: '#170034',
      secondaryColor: '#FF1F75'
    },
    redirectUrl: urls[env]['fronteiras']
  }),
  '58': () => ({
    name: 'Liga das Olimpíadas',
    logo: LigaOlimpiadasLogo,
    theme: {
      primaryColor: '#FE5E00',
      secondaryColor: '#6025E1'
    },
    redirectUrl: urls[env]['ligaOlimpiadas']
  }),
  '59': () => ({
    name: 'Mundo Kids',
    logo: MundoKidsLogo,
    theme: {
      primaryColor: '#EBB04A',
      secondaryColor: '#09AFD2'
    },
    redirectUrl: urls[env]['mundoKids']
  }),
  '60': () => ({
    name: 'Verbo - Capacitação',
    logo: verboLogo,
    theme: {
      primaryColor: '#3e02a3',
      secondaryColor: '#45cfef'
    },
    redirectUrl: urls[env]['verboCapacitacao']
  }),
  '61': () => ({
    name: 'Verbo - COPE',
    logo: verboLogo,
    theme: {
      primaryColor: '#3e02a3',
      secondaryColor: '#45cfef'
    },
    redirectUrl: urls[env]['verboCope']
  }),
  '62': () => ({
    name: 'Verbo - Educandário',
    logo: verboEducandarioLogo,
    theme: {
      primaryColor: '#0056A3',
      secondaryColor: '#E0F2FF'
    },
    redirectUrl: urls[env]['verboEducandario']
  }),
  '63': () => ({
    name: 'Verbo - Galois',
    logo: verboLogo,
    theme: {
      primaryColor: '#3e02a3',
      secondaryColor: '#45cfef'
    },
    redirectUrl: urls[env]['verboGalois']
  }),
  '64': () => ({
    name: 'Verbo - Lavem o ENEM',
    logo: verboLogo,
    theme: {
      primaryColor: '#3e02a3',
      secondaryColor: '#45cfef'
    },
    redirectUrl: urls[env]['verboLavemOENEM']
  }),
  '65': () => ({
    name: 'Verbo - PPA',
    logo: verboLogo,
    theme: {
      primaryColor: '#3e02a3',
      secondaryColor: '#45cfef'
    },
    redirectUrl: urls[env]['verboPPA']
  }),
  '66': () => ({
    name: 'Verbo - Redação Solidária',
    logo: verboLogo,
    theme: {
      primaryColor: '#3e02a3',
      secondaryColor: '#45cfef'
    },
    redirectUrl: urls[env]['verboRedacaoSolidaria']
  }),
  '68': () => ({
    name: 'Verbo - Sërios',
    logo: verboSeriosLogo,
    theme: {
      primaryColor: '#871432',
      secondaryColor: '#5F2433'
    },
    redirectUrl: urls[env]['verboSerios']
  }),
  '70': () => ({
    name: 'Verbo - Atrio',
    logo: verboAtrioLogo,
    theme: {
      primaryColor: '#023872',
      secondaryColor: '#99DFEB'
    },
    redirectUrl: urls[env]['verboAtrio']
  }),
  '71': () => ({
    name: 'Verbo - Nations',
    logo: verboNationsLogo,
    theme: {
      primaryColor: '#00ACED',
      secondaryColor: '#00268A'
    },
    redirectUrl: urls[env]['verboNations']
  })
}

export const getFractalAppData = (appId, fractalAppSource = fractalApps) => fractalAppSource[appId] && fractalAppSource[appId]()

export const getCurrentAppData = () => {
  const { app_id: appId } = getParamsFromQueryString()
  const fractalApp = getFractalAppData(appId)
  return fractalApp
}
